import ReactDOM from 'react-dom/client';
import NewsPosts from './NewsPosts';

window.initNewsPosts = (newsResourceLink) => {
  const root = ReactDOM.createRoot(document.getElementById('news-posts'));
  root.render(<NewsPosts newsResourceLink={newsResourceLink} />);
}
